
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "apiBaseUrl": "https://api.vkusilosos.ru",
  "env": "production",
  "nuxt": {
    "buildId": "593e3bc9-f442-4227-88d9-9ef94341b30f"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
